import { CompanyWizardStoreStatic } from "./CompanyWizardStoreStatic";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../react-core/Flux/Dispatcher";
import { CompanyInstructionStoreStatic } from "./CompanyInstructionStoreStatic";
import { CompanyServicePropositionStoreStatic } from "./CompanyServicePropositionStoreStatic";
import { CompanyStoreStatic } from "./CompanyStoreStatic";
import { BackOfficeProviderStoreStatic } from "./BackOfficeProviderStoreStatic";
import { BackOfficeProviderBulkValuationReportStoreStatic } from "./BackOfficeProviderBulkValuationReportStoreStatic";
import {CacheablePayloadStore, ICacheablePayloadAction} from "../../../../../react-core/Flux/CacheablePayloadStore";
import {FsaPermission} from "../../../../../Wrap/Models/Models/Company/FsaPermission";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const CompanyWizardDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const CompanyWizardStore: CompanyWizardStoreStatic = new CompanyWizardStoreStatic();
export const CompanyInstructionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const CompanyFsaPermissionsDispatcher = new Dispatcher<ICacheablePayloadAction<FsaPermission[], string>>();
export const CompanyFsaPermissionsStore = new CacheablePayloadStore(CompanyFsaPermissionsDispatcher);
export const CompanyInstructionStore: CompanyInstructionStoreStatic = new CompanyInstructionStoreStatic();
export const CompanyDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const CompanyStore: CompanyStoreStatic = new CompanyStoreStatic();
export const CompanyServicePropositionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const CompanyServicePropositionStore: CompanyServicePropositionStoreStatic = new CompanyServicePropositionStoreStatic();
export const BackOfficeProvidersDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const BackOfficeProvidersStore: BackOfficeProviderStoreStatic = new BackOfficeProviderStoreStatic();
export const BackOfficeProviderBulkValuationReportDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const BackOfficeProviderBulkValuationReportStore: BackOfficeProviderBulkValuationReportStoreStatic = new BackOfficeProviderBulkValuationReportStoreStatic();
